export class UpdateDeliveryFee {
    public orderID: string;
    public deliveryFee: number;
}
